import { BrandTile } from '@/ui/BrandMark'

/**
 * The page footer.
 *
 * ── Why a footer at all ──
 * The app had none: content simply stopped and the ground continued. That reads as a page
 * that has been cut off rather than one that has ended, and it leaves the legal links with
 * nowhere to live — they were unreachable from anywhere in the app.
 *
 * The reference's is deliberately quiet: a mark, two links and a copyright line, separated
 * from the content by a hairline and nothing else. It is a terminator, not a sitemap. A
 * second navigation surface down here would compete with the rail, which is the one thing
 * the shell has been careful not to do.
 *
 * ── "Terms of Use" and "Privacy Policy" are not links ──
 * `/terms` and `/privacy` do not exist as routes in App.tsx, and adding them is a functional
 * change out of scope for this pass. A footer link to a route that 404s is worse than no
 * link, so these render as plain, non-interactive text until the routes exist.
 */
export function AppFooter() {
  return (
    <footer className="mt-10 border-t border-line">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-6 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <div className="flex items-center gap-2.5">
          <BrandTile className="size-7 rounded-[8px]" />
          <span className="display text-sm font-bold">
            Ninja<span className="text-accent">DEX</span>
          </span>
        </div>

        <div className="flex flex-col gap-1 text-sm text-muted sm:items-end">
          <div className="flex items-center gap-4">
            <span className="text-faint">Terms of Use</span>
            <span className="h-3 w-px bg-line" aria-hidden />
            <span className="text-faint">Privacy Policy</span>
          </div>
          <span className="text-xs text-faint">© NinjaDEX 2026, All rights reserved.</span>
        </div>
      </div>
    </footer>
  )
}
